<form
  class="create-project-form space-y-6"
  [formGroup]="assignmentFormModel.form"
  (ngSubmit)="submitForm()"
>
  <div class="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,2fr)_minmax(21rem,1fr)]">
    <div class="create-project-panel space-y-5">
      <div class="grid gap-4 md:grid-cols-[minmax(0,2fr)_minmax(14rem,1fr)]">
        <div>
          <label for="title-input" class="form-label required">{{
            "INPUTS.ASSIGNMENT_TITLE" | translate
          }}</label>
          <input
            id="title-input"
            type="text"
            [placeholder]="'PLACEHOLDERS.ASSIGNMENT_TITLE' | translate"
            class="form-input"
            [class.is-invalid]="
              (titleFormControl.touched || assignmentFormModel.form.dirty) && titleFormControl.errors
            "
            [class.is-valid]="!titleFormControl.errors"
            [formControlName]="assignmentFormModel.fieldNames.title"
          />

          <div class="invalid-feedback">
            @if (titleFormControl.errors?.['required']) {
              <span>{{ "ERRORS.REQUIRED" | translate }}</span>
            }
            @if (titleFormControl.errors?.['maxlength']) {
              <span>{{
                "ERRORS.MAXLENGTH"
                  | translate
                    : {
                        requiredLength:
                          titleFormControl.errors!["maxlength"].requiredLength,
                      }
              }}</span>
            }
          </div>
        </div>

        <div class="assignment-create-date-field">
          <label for="deadline-input" class="form-label">{{
            "INPUTS.DEADLINE" | translate
          }}</label>
          <input
            id="deadline-input"
            type="date"
            class="form-input"
            [class.is-invalid]="deadlineFormControl.touched && deadlineFormControl.errors"
            [class.is-valid]="deadlineFormControl.dirty && !deadlineFormControl.errors"
            [formControlName]="assignmentFormModel.fieldNames.deadline"
          />
        </div>
      </div>

      <div>
        <label for="description-textarea" class="form-label">{{
          "INPUTS.DESCRIPTION" | translate
        }}</label>
        <div class="assignment-create-editor form-input">
          <app-custom-quill-editor
            id="description-textarea"
            [formControlName]="assignmentFormModel.fieldNames.description"
          />
        </div>
      </div>
    </div>

    <div class="create-project-panel space-y-5">
      <div class="create-project-team-card">
        <div class="create-project-team-header">
          <p class="form-label">
            {{ "INPUTS.PERFORMER" | translate }}
          </p>
          <span class="create-project-team-count">
            {{ "COMPONENTS.PROJECTS.CREATE_MODAL.SELECTED_TEAM" | translate: { count: assignmentEmployee ? 1 : 0 } }}
          </span>
        </div>

        <app-search
          customClass="form-search-input"
          [placeholderText]="'INPUTS.PERFORMER' | translate"
          [formControl]="selectedEmployeeControl"
          [items]="(projectEmployees$ | async)!"
          [filterFn]="employeeSearchConfig.filterFn"
          [formatter]="employeeSearchConfig.formatter"
          [compareFn]="employeeSearchConfig.compareFn"
          [errorMessage]="'ERRORS.INCORRECT_SELECTED_EMPLOYEE' | translate"
          (selectedItem)="onSelectEmployee($event)"
        >
        </app-search>

        <button
          type="button"
          class="form-secondary-btn create-project-add-btn"
          [disabled]="!selectedEmployee"
          (click)="addEmployee(selectedEmployee!)"
        >
          {{ "BUTTONS.ADD" | translate }}
        </button>

        <div class="create-project-team-list">
          @if (!assignmentEmployee) {
            <p class="create-project-team-empty">
              {{ "MESSAGES.EMPTY_LIST" | translate: { param: ("INPUTS.PERFORMER" | translate) } }}
            </p>
          } @else {
            <div class="create-project-team-member">
              <app-minimal-profile-info
                [profile]="assignmentEmployee"
                [fullNameClass]="'fw-bolder'"
                [collapseDetailsOnMobile]="false"
              />
              <button
                type="button"
                class="close-btn"
                [attr.aria-label]="'BUTTONS.CANCEL' | translate"
                (click)="removeEmployee(assignmentEmployee)"
              >
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="create-project-panel space-y-5 lg:col-span-2">
      <section class="assignment-create-files-card">
        <app-storage-usage-summary [usage]="storageUsage$ | async" />

        <div class="assignment-create-files-head">
          <p class="form-label">{{ "BUTTONS.FILES" | translate }}</p>
          <app-file-upload
            class="assignment-create-upload-control"
            [path]="attachmentsPath"
            [multiple]="true"
            [hidden]="false"
            [isTemporaryFiles]="true"
            (uploadedFileEvent)="onUploadFile($event)"
            (deletedFileEvent)="onDeleteFile($event)"
          />
        </div>

        @if (!files.length) {
          <p class="create-project-team-empty">
            {{ "MESSAGES.EMPTY_LIST" | translate: { param: ("COMPONENTS.ATTACHMENTS.TITLE" | translate) } }}
          </p>
        } @else {
          <div class="assignment-create-files-grid">
            @for (file of files; track file.id) {
              <article class="assignment-create-file-card">
                <div class="assignment-create-file-icon">
                  <img [src]="file.imageSrc" alt="" />
                </div>
                <p class="assignment-create-file-title" [title]="file.mappedTitle || (file.title | fileTitle)">
                  {{ file.mappedTitle || (file.title | fileTitle) }}
                </p>
                <p class="assignment-create-file-meta">
                  <span>{{ file.fileSize | fileSize }}</span>
                  @if (file.extensionName) {
                    <span>{{ file.extensionName | uppercase }}</span>
                  }
                </p>
                <button
                  type="button"
                  class="form-secondary-btn assignment-create-file-remove"
                  (click)="removeFile(file)"
                >
                  {{ "BUTTONS.REMOVE" | translate }}
                </button>
              </article>
            }
          </div>
        }
      </section>
    </div>
  </div>

  <div class="create-project-actions">
    <button type="button" class="form-secondary-btn" (click)="onCancel()">
      {{ "BUTTONS.CANCEL" | translate }}
    </button>

    <button
      type="submit"
      class="form-primary-btn"
      [disabled]="assignmentFormModel.form.invalid"
    >
      {{ "BUTTONS.CREATE_ASSIGNMENT" | translate }}
    </button>
  </div>
</form>
